const env = require('../utils/env').env;

const HeaderMixin = {
    getOrganization: function() {
        return this.props.Organization || {};
    },

    getLocation: function() {
        return this.props.Location || {};
    },

    locationFieldIsVisible: function(field) {
        let loc = this.getLocation();
        return (loc && loc[field] && loc[field].length);
    },

    countryFieldIsVisible: function() {
        let loc = this.getLocation();
        if (loc.Country !== 'United States')
            return this.locationFieldIsVisible('Country');
        return false;
    },

    getEmailBody: function() {
        let url = env.getBaseUrl() + this.props.PublishedURL;
        let body = encodeURIComponent(this.props.Content?this.props.Content:'' + "\n\n " + url);
        return body;
    },

    getFarmerMailTo: function() {
        let emailbody = this.getEmailBody();
        return "mailto:" + this.props.Location.ContactEmail + "?subject=Information Request&body=" + emailbody;
    },

    getProductFields: function() {
        let fields = {
            CertifiedOrganic: 'Certified Organic',
            NonGMO: 'Non-GMO',
            AntibioticFree: 'No Antibiotics',
            FreeRange: 'Free Range',
            HormoneFree: 'No Hormones',
            AllNatural: 'All Natural',
            ChemicalFree: 'Chemical Free',
            Kosher: 'Kosher',
            Transitional: 'Transitional',
            Conventional: 'Certified Naturally Grown'
        };
        return fields;
    },

    formatURL: function(url) {
        if (!url)
            return '';
        let re = /^(http|https):\/\//;

        if (re.exec(url.toLowerCase()) === null)
            return 'http://' + url;

        return url;
    },
};

exports.HeaderMixin = HeaderMixin;